import { EditorUtils } from '../../util/editor-utils.js';
import 'vue';
import '@ssml-editor/core';
import '../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import '../../_virtual/lodash.js';

const withText = (editor) => {
  const newEditor = editor;
  newEditor.getText = () => {
    return EditorUtils.getText(newEditor, []);
  };
  return newEditor;
};

export { withText };
//# sourceMappingURL=with-text.js.map
